import { HttpContextToken } from '@angular/common/http';

// Define the context token for controlling the spinner
export const SPINNER = new HttpContextToken<boolean>(() => true);
